import { InViewGuard } from 'components/InViewGuard'
import { ReactNode, forwardRef, DOMAttributes, useState, useMemo } from 'react'
import { StyledLinkProps } from 'utils/styled'
import { SContainer, SFooterHeaderContainer, SHeaderContainer, SMainContent } from './Layout.styled'
import { layoutContext } from './context'
import { InterpolationPrimitive } from '@emotion/serialize'
import { css } from '@emotion/react'

export const Layout = forwardRef<
  HTMLDivElement,
  {
    header?: ReactNode
    footer?: ReactNode
    mainContentCss?: InterpolationPrimitive
    noStickyHeader?: boolean
  } & StyledLinkProps &
    DOMAttributes<HTMLDivElement>
>(({ header, footer, children, as, noStickyHeader, ...props }, ref) => {
  const [scrolled, setScrolled] = useState(false)
  const context = useMemo(() => ({ scrolled }), [scrolled])

  return (
    <layoutContext.Provider value={context}>
      <SContainer as={as} {...props}>
        <a
          href="#main-content"
          css={css`
            position: absolute;
            left: -9999px;
            top: auto;
            width: 1px;
            height: 1px;
            overflow: hidden;
            &:focus {
              position: fixed;
              top: 0;
              left: 0;
              width: auto;
              height: auto;
              padding: 0.5rem 1rem;
              background: var(--c-blue500);
              color: white;
              z-index: 100;
              font-family: var(--f-text);
              text-decoration: none;
              font-weight: bold;
            }
          `}
        >
          Skip to main content
        </a>
        <InViewGuard setIsInView={(inView) => setScrolled(!inView)} />
        <SHeaderContainer sticky={!noStickyHeader}>{header}</SHeaderContainer>
        <SMainContent id="main-content" css={props.mainContentCss} hasFooter={!!footer} ref={ref}>
          {children}
        </SMainContent>
        <SFooterHeaderContainer>{footer}</SFooterHeaderContainer>
      </SContainer>
    </layoutContext.Provider>
  )
})
Layout.displayName = 'Layout'
